var exports = {
  "k": "xaf9ae18d--6be3f7--container",
};

module.exports = exports;
